import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetDashboardDataQuery } from '../../redux/apiSlice';
import PageLoader from '../PageLoader';
import ErrorPage from '../ErrorPage';
import PaywallPing from './PaywallPing';
import DashboardRoot from './DashboardRoot';

const Dashboard = () => {
    const { slug } = useParams();
    const {
        data: fetchedDashboard,
        isFetching,
        error
    } = useGetDashboardDataQuery(slug, { skip: window.dashboard });

    const dashboard = window.dashboard || fetchedDashboard;

    if (isFetching) return <PageLoader />;
    if (error) return <ErrorPage />;

    return (
        <PaywallPing dashboard={dashboard}>
            <DashboardRoot dashboard={dashboard} />
        </PaywallPing>
    );
};

export default Dashboard;
